import { Maybe } from 'graphql/jsutils/Maybe';
import { get } from 'lodash';
import { IconType, VideoCamera, Volume } from 'icons';

export enum ToolTypes {
  video = 'video',
  audio = 'audio',
}

export const toolMediaIcons: {
  [key in ToolTypes]?: IconType;
} = {
  [ToolTypes.video]: VideoCamera,
  [ToolTypes.audio]: Volume,
};

export const getToolMediaTypeIcon = (
  type: Maybe<string>,
): IconType | undefined => {
  if (type) {
    return get(toolMediaIcons, type);
  }

  return;
};
